var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OrganizationFields',{attrs:{"v":_vm.v}}),_c('MrpaTrustee',{attrs:{"v":_vm.v.trustee,"label":"Сведения о представителе юридического лица"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }